import React from 'react';
import { Section, Container, Card } from '../common';
import {
  Beef,
  Coffee,
  CupSoda,
  IceCreamBowl,
  Pizza,
  Sandwich,
  Soup,
  Store,
  UtensilsCrossed
} from 'lucide-react';

const segments = [
  {
    icon: <Sandwich size={30} />,
    title: 'Hamburguerias',
    description: 'Combos, complementos, adicionais e operação rápida no delivery, balcão e salão.'
  },
  {
    icon: <Pizza size={30} />,
    title: 'Pizzarias',
    description: 'Sabores, bordas, tamanhos, promoções por dia da semana e pedidos agendados.'
  },
  {
    icon: <UtensilsCrossed size={30} />,
    title: 'Restaurantes',
    description: 'Cardápio completo, gestão de pedidos, mesas, financeiro e relacionamento com clientes.'
  },
  {
    icon: <CupSoda size={30} />,
    title: 'Lanchonetes',
    description: 'Pedidos simples, sugestões de bebidas, cupons e atendimento integrado ao WhatsApp.'
  },
  {
    icon: <IceCreamBowl size={30} />,
    title: 'Açaís e sobremesas',
    description: 'Montagem personalizada, adicionais, tamanhos e aumento de ticket no carrinho.'
  },
  {
    icon: <Soup size={30} />,
    title: 'Marmitarias',
    description: 'Programação de produção, pedidos recorrentes, entrega e controle do fluxo diário.'
  },
  {
    icon: <Store size={30} />,
    title: 'Conveniências',
    description: 'Catálogo por categorias, disponibilidade de produtos e venda direta pelo próprio canal.'
  },
  {
    icon: <Coffee size={30} />,
    title: 'Cafeterias e docerias',
    description: 'Vitrine digital, combos, fidelidade e campanhas para estimular recompra.'
  },
  {
    icon: <Beef size={30} />,
    title: 'Pastelarias e food trucks',
    description: 'Operação enxuta, cardápio por QR Code, atendimento ágil e controle dos pedidos.'
  }
];

const Segments = () => {
  return (
    <Section id="segmentos" className="bg-light-custom">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <span className="section-eyebrow">Segmentos atendidos</span>
          <h2 className="fw-bold mb-3">Feito para quem vende comida todos os dias</h2>
          <p className="text-secondary lead mx-auto max-width-700">
            O Léo Delivery se adapta a diferentes operações de alimentação, do delivery
            enxuto ao restaurante com salão, balcão, cozinha e múltiplos canais.
          </p>
        </div>

        <div className="row g-4">
          {segments.map((segment, index) => (
            <div key={segment.title} className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={index * 60}>
              <Card className="segment-card h-100">
                <div className="segment-card__icon" aria-hidden="true">
                  {segment.icon}
                </div>
                <h3 className="h5 fw-bold mb-3">{segment.title}</h3>
                <p className="text-secondary mb-0 small">{segment.description}</p>
              </Card>
            </div>
          ))}
        </div>

        <div className="segments-cta" data-aos="fade-up">
          <p className="mb-0 fw-semibold">Seu segmento não apareceu na lista?</p>
          <a href="#contato" className="btn btn-primary-custom">Falar com especialista</a>
        </div>
      </Container>
    </Section>
  );
};

export default Segments;
